import React from "react";
import { useTranslation } from "react-i18next";

// Renders a legal document stored in the locale files as an ordered list of blocks:
//   { type: "title" | "part" | "article" | "p", text }
//   { type: "ul" | "ol", items: [] }
//   { type: "hr" }
// Text values may contain inline HTML (<strong>, <em>, <a>) produced from the source documents.
const LegalDocument = ({ i18nKey }) => {
  const { t } = useTranslation();
  const blocks = t(`${i18nKey}.blocks`, { returnObjects: true });

  if (!Array.isArray(blocks)) return null;

  const ArticleTag = blocks.some((b) => b.type === "part") ? "h3" : "h2";

  return (
    <div className="legal-document">
      {blocks.map((block, i) => {
        switch (block.type) {
          case "title":
            return <h1 key={i} className="legal-document-title" dangerouslySetInnerHTML={{ __html: block.text }} />;
          case "part":
            return <h2 key={i} className="legal-document-part" dangerouslySetInnerHTML={{ __html: block.text }} />;
          case "article":
            return <ArticleTag key={i} className="legal-document-article" dangerouslySetInnerHTML={{ __html: block.text }} />;
          case "ul":
          case "ol": {
            const List = block.type;
            return (
              <List key={i}>
                {block.items.map((item, j) => (
                  <li key={j} dangerouslySetInnerHTML={{ __html: item }} />
                ))}
              </List>
            );
          }
          case "hr":
            return <hr key={i} />;
          default:
            return <p key={i} dangerouslySetInnerHTML={{ __html: block.text }} />;
        }
      })}
    </div>
  );
};

export default LegalDocument;
